import { supportedLanguages } from "../../utils/displayValues";
import { useGet } from "../useGet";
import { responseTextSerializer } from "../../utils";

export const useGetUserGuide = (language: supportedLanguages) => {
  return useGet({
    url: `/docs/user_guide/user_guide-v1-${language}.md`,
    serializer: responseTextSerializer,
  });
};
